import React, { Component } from 'react'
import { MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import UserProfileService from '../../../../shared/services/UserProfile.service'
import UserTrainingQuizService from '../../../../shared/services/UserTrainingQuiz.service'
import TrainingsPageService from '../../shared/TrainingsPage.service'
import TrainingQuestion from '../TrainingQuestion/TrainingQuestion.component'
import { toast } from 'react-toastify'

import './TrainingQuiz.scss'

const arraysMatch = (a, b) => {
  const sorted1 = [...a].sort()
  const sorted2 = [...b].sort()
  return sorted1.length === sorted2.length && sorted1.every((v, i) => v === sorted2[i])
}

class TrainingQuiz extends Component {
  state = {
    training_quiz: null,
    training_questions: [],
    training_answers: [],
    valid_answers: [],
    agent_answer: null,
    loading: false,
    submitted: false,
    currentStep: 0,
    showResults: false,
  }

  componentDidMount() {
    const rawAnswers = Array.isArray(this.props.training_answers) ? this.props.training_answers : []
    const answers = rawAnswers.map(item => ({ ...item, checked: false }))

    const questions = Array.isArray(this.props.training_questions) ? this.props.training_questions : []
    const quizs = questions.map(question => {
      const correctAnswerIds = answers.filter(a => a.question_id === question.id && a.is_correct).map(a => a.id)
      return {
        question: question.id,
        answers: [],
        correct_answers: correctAnswerIds,
        isMultiple: correctAnswerIds.length > 1,
      }
    })

    this.setState({
      training_quiz: this.props.training_quiz,
      training_questions: this.props.training_questions,
      training_answers: answers,
      agent_answer: quizs,
    })
  }

  onClickAnswer = answer => {
    const agentAnswer = this.state.agent_answer?.find(a => a.question === answer.question_id)
    const isMultiple = agentAnswer?.isMultiple

    const updated_answers = this.state.training_answers.map(item => {
      if (item.id === answer.id) {
        item.checked = isMultiple ? !item.checked : true
      } else if (item.question_id === answer.question_id && !isMultiple) {
        item.checked = false
      }
      return item
    })

    const agent_answer_data = this.state.agent_answer.map(data => {
      if (data.question === answer.question_id) {
        if (isMultiple) {
          const idx = data.answers.indexOf(answer.id)
          if (idx > -1) {
            data.answers = data.answers.filter(a => a !== answer.id)
          } else {
            data.answers = [...data.answers, answer.id]
          }
        } else {
          data.answers = [answer.id]
        }
      }
      return data
    })

    this.setState({
      training_answers: updated_answers,
      agent_answer: agent_answer_data,
    })
  }

  submit = async () => {
    this.setState({ loading: true, submitted: true })

    const agent_answers = this.state.agent_answer
    const allCorrect = agent_answers?.every(qa => arraysMatch(qa.answers, qa.correct_answers))

    if (allCorrect) {
      this.setState({ valid_answers: agent_answers })
      try {
        const user_training_quiz = (
          await UserTrainingQuizService.search({
            search: {
              quiz_id: this.state.training_quiz.id,
              training_id: this.state.training_quiz.training_id,
              user_id: UserProfileService.getUserId(),
            },
            pagination: false,
          })
        )?.models

        if ((user_training_quiz || []).length > 0) {
          await UserTrainingQuizService.update(user_training_quiz[0].id, {
            passed: 1,
          })
        } else {
          await UserTrainingQuizService.store({
            quiz_id: this.state.training_quiz.id,
            training_id: this.state.training_quiz.training_id,
            user_id: UserProfileService.getUserId(),
            answers: JSON.stringify(
              agent_answers.map(qa => ({
                question: qa.question,
                answers: qa.answers,
              }))
            ),
            passed: 1,
          })
        }

        try {
          await TrainingsPageService.markAttendedByQuiz(this.state.training_quiz.training_id)
        } catch (err) {
          console.error('Failed to mark training attended after passing quiz.', err)
        }

        this.setState({ loading: false, submitted: true })
        toast.success('Your answers are correct!', {
          position: toast.POSITION.TOP_RIGHT,
        })

        const user_training_quizes = (
          await UserTrainingQuizService.search({
            search: { user_id: UserProfileService.getUserId() },
            pagination: false,
          })
        )?.models
        TrainingsPageService.UserTrainingQuizSubject.next(user_training_quizes)

        // close
        if (typeof this.props?.onSuccess === 'function') this.props.onSuccess()
      } catch (error) {
        this.setState({ loading: false, submitted: true })
        toast.error('Something went wrong!', {
          position: toast.POSITION.TOP_RIGHT,
        })
      }
    } else {
      try {
        const valid_answers = agent_answers?.filter(qa => arraysMatch(qa.answers, qa.correct_answers))

        this.setState({
          loading: false,
          submitted: true,
          showResults: true,
          valid_answers,
        })
        toast.error(`${valid_answers?.length}/${agent_answers.length} correct!`, { position: toast.POSITION.TOP_RIGHT })
      } catch (error) {
        this.setState({ loading: false, submitted: true })
        toast.error('Something went wrong!', {
          position: toast.POSITION.TOP_RIGHT,
        })
      }
    }
  }

  goNext = () => {
    if (this.state.currentStep < this.state.training_questions.length - 1) {
      this.setState({ currentStep: this.state.currentStep + 1 })
    }
  }

  goPrev = () => {
    if (this.state.currentStep > 0) {
      this.setState({ currentStep: this.state.currentStep - 1 })
    }
  }

  isCurrentAnswered = () => {
    const currentQuestion = this.state.training_questions[this.state.currentStep]
    if (!currentQuestion) return false
    const agentAnswer = this.state.agent_answer?.find(a => a.question === currentQuestion.id)
    return agentAnswer?.answers?.length > 0
  }

  retryQuiz = () => {
    const answers = this.state.training_answers.map(item => ({
      ...item,
      checked: false,
    }))
    const quizs = this.state.training_questions.map(question => {
      const correctAnswerIds = answers.filter(a => a.question_id === question.id && a.is_correct).map(a => a.id)
      return {
        question: question.id,
        answers: [],
        correct_answers: correctAnswerIds,
        isMultiple: correctAnswerIds.length > 1,
      }
    })

    this.setState({
      training_answers: answers,
      agent_answer: quizs,
      submitted: false,
      showResults: false,
      currentStep: 0,
      valid_answers: [],
    })
  }

  render() {
    const { currentStep, training_questions, submitted, showResults, loading } = this.state
    const totalSteps = training_questions?.length || 0
    const isLastStep = currentStep === totalSteps - 1
    const isFirstStep = currentStep === 0
    const currentQuestion = training_questions?.[currentStep]
    const currentAgentAnswer = this.state.agent_answer?.find(a => a.question === currentQuestion?.id)
    const progress = totalSteps > 0 ? Math.round(((currentStep + 1) / totalSteps) * 100) : 0
    const allAnswered = !this.state.agent_answer?.some(a => !a?.answers?.length)

    if (showResults) {
      const correctCount = this.state.valid_answers?.length || 0

      return (
        <div className='training-quiz-wizard'>
          <div className='quiz-header'>
            <h5 className='text-center'>Quiz Results</h5>
            <p className='text-center quiz-score'>
              You got <strong>{correctCount}</strong> out of <strong>{totalSteps}</strong> correct
            </p>
          </div>
          <div className='quiz-results-list'>
            {training_questions?.map((question, index) => {
              const qa = this.state.agent_answer?.find(a => a.question === question.id)
              return (
                <div key={`result-${question.id}-${index}`} className='quiz-result-item'>
                  <TrainingQuestion
                    question={question}
                    answers={this.state.training_answers?.filter(answer => answer.question_id === question.id)}
                    onClickAnswer={() => {}}
                    submitted={true}
                    validAnswers={this.state.valid_answers}
                    isMultiple={qa?.isMultiple}
                  />
                </div>
              )
            })}
          </div>
          <div className='quiz-navigation mt-3'>
            <MDBBtn type='button' color='indigo' className='btn-block' onClick={this.retryQuiz}>
              <MDBIcon icon='redo' className='mr-2' />
              Try Again
            </MDBBtn>
          </div>
        </div>
      )
    }

    return (
      <div className='training-quiz-wizard'>
        <div className='quiz-header'>
          <h5 className='text-center'>Training Quiz</h5>
          <div className='quiz-progress-info'>
            Question {currentStep + 1} of {totalSteps}
          </div>
          <div className='quiz-progress-bar'>
            <div className='quiz-progress-fill' style={{ width: `${progress}%` }} />
          </div>
        </div>

        <div className='quiz-step-dots'>
          {training_questions?.map((_, idx) => {
            const isAnswered = this.state.agent_answer?.[idx]?.answers?.length > 0
            return (
              <span
                key={`dot-${idx}`}
                className={`step-dot${idx === currentStep ? ' active' : ''}${isAnswered ? ' answered' : ''}`}
                onClick={() => this.setState({ currentStep: idx })}
                title={`Question ${idx + 1}`}
              />
            )
          })}
        </div>

        <div className='quiz-question-area'>
          {currentQuestion && (
            <TrainingQuestion
              key={`quiz-q-${currentQuestion.id}`}
              question={currentQuestion}
              answers={this.state.training_answers?.filter(answer => answer.question_id === currentQuestion.id)}
              onClickAnswer={this.onClickAnswer}
              submitted={submitted}
              validAnswers={this.state.valid_answers}
              isMultiple={currentAgentAnswer?.isMultiple}
            />
          )}
        </div>

        <div className='quiz-navigation'>
          <MDBRow>
            <MDBCol size='6'>
              <MDBBtn
                type='button'
                outline
                color='indigo'
                disabled={isFirstStep}
                onClick={this.goPrev}
                className='btn-block'
              >
                <MDBIcon icon='chevron-left' className='mr-1' /> Back
              </MDBBtn>
            </MDBCol>
            <MDBCol size='6'>
              {isLastStep ? (
                <MDBBtn
                  type='button'
                  color='success'
                  disabled={!allAnswered || loading}
                  onClick={evt => this.submit(evt)}
                  className='btn-block'
                >
                  {loading ? (
                    'Submitting...'
                  ) : (
                    <>
                      Submit <MDBIcon icon='check' className='ml-1' />
                    </>
                  )}
                </MDBBtn>
              ) : (
                <MDBBtn
                  type='button'
                  color='indigo'
                  disabled={!this.isCurrentAnswered()}
                  onClick={this.goNext}
                  className='btn-block'
                >
                  Next <MDBIcon icon='chevron-right' className='ml-1' />
                </MDBBtn>
              )}
            </MDBCol>
          </MDBRow>
        </div>
      </div>
    )
  }
}

export default TrainingQuiz
